module.exports = __webpack_public_path__ + "img/gateway__will.8cc0859.svg";